export default {
  insurances: {},
  reasons: null,
  appointmentTypes: [],
  appointmentTypesEnabled: false,
  calendars: {},
  createdAppointment: null,
  allDocLocs: null,
  initCalendarsInfo: [],
  allLocations: [],
  allProviders: [],
  calendarIndexToLocationAndProviderMap: {},
  calendarIdToIndexMap: {},
  savedCalendarsIds: new Set(),
  requestQueue: [],
  googleMapsApiKey: null
}
